var map = {
	".": [
		4044,
		9,
		44
	],
	"./": [
		4044,
		9,
		44
	],
	"./ValueContainer": [
		2369,
		9
	],
	"./ValueContainer.tsx": [
		2369,
		9
	],
	"./Values": [
		5383,
		9
	],
	"./Values.styled": [
		498,
		9
	],
	"./Values.styled.ts": [
		498,
		9
	],
	"./Values.tsx": [
		5383,
		9
	],
	"./animations/audit": [
		7642,
		3,
		642
	],
	"./animations/audit.json": [
		7642,
		3,
		642
	],
	"./animations/consulting": [
		1094,
		3,
		94
	],
	"./animations/consulting.json": [
		1094,
		3,
		94
	],
	"./animations/debt": [
		5862,
		3,
		862
	],
	"./animations/debt.json": [
		5862,
		3,
		862
	],
	"./animations/e2e": [
		3548,
		3,
		548
	],
	"./animations/e2e.json": [
		3548,
		3,
		548
	],
	"./animations/iterations": [
		1432,
		3,
		432
	],
	"./animations/iterations.json": [
		1432,
		3,
		432
	],
	"./animations/uxui": [
		5411,
		3,
		411
	],
	"./animations/uxui.json": [
		5411,
		3,
		411
	],
	"./index": [
		4044,
		9,
		44
	],
	"./index.ts": [
		4044,
		9,
		44
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2952;
module.exports = webpackAsyncContext;